import Vue from 'vue/dist/vue.js';
const axios = require('axios');
import dateFormat from "dateformat";
import  { i18n }  from "dateformat";

i18n.monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "Mai",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Okt",
  "Nov",
  "Des",
  "Januar",
  "Februar",
  "Mars",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Desember",
];


export default {
    name: 'product-auction',
    _el: null,

    init() {
        this._el = document.getElementById('js_productAuction');

        if (this._el) {
            this.run();
        }
    },

    run ()
    {
        new Vue({
            el: '#js_productAuction',

            delimiters: ['@{', '}'],

            data:
            {
                status          : 'ready',
                chsh            : '',
                myBid           : 0,
                auction         : null,
                auctionId       : null,
                updateAuction   : false,
                countdownTime   : '',
                bids            : [],
                showBids        : false,
                responseStatus  : null,
                responseTitle   : null,
                responseMessage : null,
                xhrActive       : false,
                showAutoBid     : false,
                invalidAmount   : false
            },

            created()
            {
                const rootEl = document.getElementById('js_productAuction');
                this.host = document.querySelector('[name="site_root"]').content;
                rootEl.classList.add('is-ready');
                this.auctionId = parseInt(rootEl.dataset.auctionid);

                this.chsh = rootEl.dataset.chsh;
                this.getAuction();

                setInterval(this.countdown, 1000);

                this.initPusher();
            },

            filters:
            {
                padLeft (auctionId)
                {
                    return auctionId.toString().padStart(6, '0');
                },

                formatDate (value)
                {
                    const date = new Date(value)
                    return dateFormat(date, "dd.mm.yyyy', kl.' HH:MM");
                },

                formatShortDate (value)
                {
                    const date = new Date(value)
                    return dateFormat(date, "dd mmm HH:MM");
                },

                formatCurrency(value)
                {
                    const formatter = new Intl.NumberFormat('nb-NO', {
                          style: 'currency',
                          currency: 'NOK',

                          // These options are needed to round to whole numbers if that's what you want.
                          //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
                          //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
                    });

                    return formatter.format(value);
                },
            },

            computed :
            {
                currentPrice()
                {
                    if (this.auction) {
                        return (this.bids.length) ? this.bids[0].amount :this.auction.min_sales_price;
                    }
                },

                minimumBid()
                {
                    if (this.auction) {
                        return (this.bids.length) ? this.bids[0].amount+this.auction.min_step :this.auction.min_sales_price;
                    }
                },

                showAutoBidCss() {
                    return (this.showAutoBid) ? 'active' : '';
                },

                invalidAmountCss()
                {
                    return (this.invalidAmount) ? 'bid-input--error ' : '';
                }
            },

            methods:
            {
                getSchedule()
                {
                    let schedule = 'passed';

                    if (this.auction) {
                        const now = new Date();
                        const startDt = new Date(this.auction.start_datetime);
                        const endDt = new Date(this.auction.end_datetime);

                        // #1 running
                        // startDt is less than now
                        // endDt is bigger than now
                        if (startDt < now && endDt > now) {
                            schedule = 'running';
                            // #2 pending
                            // startDt is bigger than now
                            // endDt is bigger than now
                        } else if (startDt > now && endDt > now) {
                            schedule = 'pending';
                        }
                    }

                    return schedule;
                },

                isAuctionPassed()
                {
                    return (this.getSchedule() === 'passed');
                },

                countdown()
                {
                    if (!this.isAuctionPassed()) {
                        const date = (this.getSchedule() === 'pending') ? this.auction.start_datetime : this.auction.end_datetime;
                        const countDownDate = new Date(date).getTime();

                        this.calcTimeDifference(countDownDate);
                    }
                },

                calcTimeDifference(countDownDate)
                {
                    // Get today's date and time
                    const now = new Date().getTime();

                    // Find the distance between now and the count down date
                    const distance = countDownDate - now;

                    // Time calculations for days, hours, minutes and seconds
                    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    const difference = days + "d " + hours + "t "+ minutes + "min " + seconds + "sek ";

                    this.countdownTime = difference;
                },

                getAuction()
                {
                    if (Number.isInteger(this.auctionId)) {
                        const endpoint = 'actions/mm/auction/show';
                        const queryArgs = { auction_id : this.auctionId };

                        this.rest(endpoint, queryArgs, 'getAuction__callback');
                    } else {
                        console.error('invalid auction id '+this.auctionId);
                    }
                },

                getAuction__callback(response)
                {
                    // console.log("getAuction__calback");
                    // console.log(response.data);
                    if (response.data.item && typeof response.data.item === 'object') {
                        this.auction = response.data.item;
                        this.bids = this.auction.bids;
                        this.countdown();

                        if (this.updateAuction) {
                            clearInterval(this.updateAuction);
                        }

                        if (this.auction.schedule !=='passed') {
                            this.myBid = (!this.myBid) ? this.minimumBid : this.myBid;
                            this.updateAuction = setInterval(this.getAuction, 60000);
                        }

                    } else {
                        this.responseStatus = 'error';
                        this.responseTitle = 'Ugyldig auksjon';
                    }
                },

                prepareData(auto)
                {
                    const token = document.querySelector('[name="CRAFT_CSRF_TOKEN"]');

                    const bodyFormData = new FormData();

                    bodyFormData.append('amount', this.myBid);
                    bodyFormData.append('auction_id', this.auction.id);
                    bodyFormData.append('_token', token.value);
                    bodyFormData.append('CRAFT_CSRF_TOKEN', token.value);
                    bodyFormData.append('auto', auto);

                    return bodyFormData;
                },

                canSubmit()
                {
                    return (! this.xhrActive && parseInt(this.myBid) >= this.minimumBid);
                },

                storeBid(auto)
                {
                    this.invalidAmount = false;

                    if (this.canSubmit()) {
                        const url = 'actions/mm/auction/store-bid';
                        const postData = this.prepareData(auto);
                        this.xhrActive = true;

                        this.restPost(url, postData, 'storeBid__callback', 'storeBid__error');
                    } else {
                        this.invalidAmount = true;
                    }
                },

                storeBid__callback(response)
                {
                    if (typeof response === 'object' && typeof response.data.status === 'string') {
                        this.responseStatus  = response.data.status;
                        this.responseTitle   = response.data.title;
                        this.responseMessage = response.data.messages;

                        if (this.responseStatus==='ok') {
                            this.myBid = null;
                            this.getAuction();
                        }
                    }

                    this.xhrActive = false;

                    this.scrollToForm();
                },

                storeBid__error(error)
                {
                    console.log('onSubmit__error');
                    console.log(error);
                    this.responseStatus = 'error';
                    this.responseMessage = error;
                    this.scrollToForm();
                },

                scrollToForm()
                {
                    const el = document.getElementById('js_productAuction');
                    el.style.top = (el.offsetTop-16)+"px";
                    el.scrollIntoView({block: "start", behavior: "smooth"});
                },

                rest (endpoint, queryArgs, callback)
                {
                    // this.responseStatus = this.responseMessage = this.responseTitle = null;

                    let queryString = "";
                    for (var i in queryArgs) {
                        queryString += i + "=" + queryArgs[i]+"&";
                    }
                    const url = this.host + endpoint + "?" + queryString;

                    axios.get(url)
                        .then(this[callback])
                        .catch(function (error) {});
                },

                restPost(endpoint, queryArgs, callback,  callback__error)
                {
                    this.responseStatus = this.responseMessage = this.responseTitle = null;
                    const headers = { "Content-Type": "multipart/form-data" };

                    const url = this.host + endpoint;
                    axios.post(url, queryArgs, headers)
                        .then(this[callback])
                        .catch(this[callback__error]);
                },

                initPusher()
                {
                    console.log('init pusher');
                    this.pusher = new Pusher('0cfdfa8ce01d3ba67f5d', { cluster: 'eu' });
                    this.channel = this.pusher.subscribe('auctions');
                    this.channel.bind('auction-event', this.auctionEvent__callback);
                },

                auctionEvent__callback(data)
                {
                    console.log('auctionEvent__callback');
                    console.log(data);
                    if (typeof data === 'object' && data.event==='new-bid' && data.id == this.auctionId) {
                        this.getAuction();
                    }
                },

                toggleShowAutoBid()
                {
                    this.showAutoBid = ! this.showAutoBid;
                }

            }
        });

    }
}